import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { MainScrappingWrapper } from './scrapping-forms/MainScrapping'
import { MainScrappingWrapperPdf } from './pdf-scrapping/MainScrappingPdf'
import { MainMergingFilesWrapper } from './merging-files/MainMerging'


const MergingPage = () => {
  return (
    <Routes>
     
      <Route index element={
            <>
              <PageTitle >Add your website</PageTitle>
              <MainMergingFilesWrapper />
            </>
          } />
    </Routes>
  )
}



export default MergingPage;
